export enum SignalrStatus {
  None = 'None',
  Connected = 'Connected',
  Reconnecting = 'Reconnecting',
  Reconnected = 'Reconnected',
  Disconnected = 'Disconnected',
  Error = 'Error',
}
